import { render, staticRenderFns } from "./AdultMarketingPoints.vue?vue&type=template&id=17c304e7&scoped=true&"
import script from "./AdultMarketingPoints.vue?vue&type=script&lang=ts&"
export * from "./AdultMarketingPoints.vue?vue&type=script&lang=ts&"
import style0 from "./AdultMarketingPoints.vue?vue&type=style&index=0&id=17c304e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c304e7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VImg,VRow})
